import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUI} from "./VanillaReaderUI";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";

export interface VanillaReaderUiDialogPublicationLandmarksController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
 * # VanillaReaderUiDialogPublicationLandmarksController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogPublicationLandmarks` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogPublicationLandmarks
 *
 * */
export class VanillaReaderUiDialogPublicationLandmarksController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogLandmarks.onLandmarkItemClicked(vanillaReaderUiContext._onDialogLandmarksItemSelected.bind(vanillaReaderUiContext));
    }

    _onDialogLandmarksItemSelected(locator: string | undefined): void {
        if(locator) {
            this.navigateTo(locator);
            this.dialogLandmarks.close();
        }

    }
}
